import SettingsIcon from '@mui/icons-material/Settings';

import SettingCreate from './SettingCreate';
import SettingEditEmbedded from './SettingEditEmbedded';
import SettingList from './SettingList';

export default {
  list: SettingList,
  create: SettingCreate,
  edit: SettingEditEmbedded,
  icon: SettingsIcon,
  recordRepresentation: (record: any) => `${record.key}`,
};
